import React, { Component, useContext } from "react";
import axios from "axios";
import Explore from "./Explore";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { toast } from "react-toastify";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import TextField from "@material-ui/core/TextField";
import {
  Card,
  Row,
  Col,
  Progress,
  CardBody,
  CardHeader,
  CardFooter,
  Button,
  Label,
} from "reactstrap";
import Moment from "react-moment";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import { Link } from "react-router-dom";
import play from "../../assets/images/icons/google-play.svg";
import qrsvg from "../../assets/images/icons/qrcode-play-store.svg";
import firsthead from "../../assets/images/first-time-login.png";
import Chip from "@material-ui/core/Chip";
import VideoLibraryIcon from "@material-ui/icons/VideoLibrary";
import DoneIcon from "@material-ui/icons/Done";
import AssignmentSharpIcon from "@material-ui/icons/AssignmentSharp";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import Fab from "@material-ui/core/Fab";
import Spinner from "../sample/spinner";
import IconButton from "@material-ui/core/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faCheckCircle,
  faDownload,
  faVideo,
  faCalendarAlt,
  faPaperPlane,
  faAngleDown,
  faAngleUp,
  faPlusCircle,
  faNewspaper,
} from "@fortawesome/free-solid-svg-icons";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import EventIcon from "@material-ui/icons/Event";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";

import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import "shepherd.js/dist/css/shepherd.css";
import { ShepherdTour, ShepherdTourContext } from "react-shepherd";

var format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
// var regex = /^[0-9a-zA-Z\_]+$/;
var regex = /^[0-9a-zA-Z ]+$/;
function CircularProgressWithLabel(props) {
  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress variant="determinate" {...props} />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          variant="caption"
          component="div"
          color="textSecondary"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

//shef
const tourOptions = {
  defaultStepOptions: {
    cancelIcon: {
      enabled: true,
    },
  },
  // useModalOverlay: true,
};

function ShefButton() {
  const tour = useContext(ShepherdTourContext);
  return (
    <button
      className=" btn btn-getstarteds ttxt-f"
      onClick={tour.start}
      style={{
        marginBottom: "9px",
      }}
    >
      Start PlatForm Tour
    </button>
  );
}

const steps = [
  {
    id: "welcome",
    title: "Welcome to Eduplusnow",
    text: [
      `
      <p>
     Thank you for choosing us,Please click on next.
      </p>
      `,
    ],
    attachTo: { element: ".hero-welcome", on: "right" },
    classes: "shepherd shepherd-welcome ",
    scrollTo: true,
    buttons: [
      {
        type: "cancel",
        classes: "shepherd-button-secondary",
        text: "Exit",
      },
      {
        type: "next",
        text: "Next",
      },
    ],
  },
  {
    id: "mobapplication",
    title: "Mobile Application",
    text: "You can download our Android application by scanning QR code.",
    attachTo: { element: ".mobileapp", on: "left" },
    classes: "shepherd shepherd-welcome",
    buttons: [
      {
        type: "back",
        classes: "shepherd-button-secondary",
        text: "Back",
      },
      {
        type: "next",
        text: "Next",
      },
    ],
  },
  {
    id: "explorecourse",
    title: "Explore Categories",
    text: "Click here, To explore various Course categories.",
    attachTo: { element: ".cards-sider", on: "left" },
    classes: "shepherd shepherd-welcome",
    scrollTo: true,
    buttons: [
      {
        type: "back",
        classes: "shepherd-button-secondary",
        text: "Back",
      },
      {
        type: "next",
        text: "Next",
      },
    ],
  },

  {
    id: "knowmore",
    title: "Know More",
    text: "To buy a course, that you are intrested in click on know more button, You will be redirected to detail course information page from that page you will be redirected to payment gateway.",
    attachTo: { element: ".shef-btn", on: "bottom" },
    classes: "shepherd shepherd-welcome",
    scrollTo: true,
    buttons: [
      {
        type: "back",
        classes: "shepherd-button-secondary",
        text: "Back",
      },
      {
        type: "next",
        text: "Next",
      },
    ],
  },
  {
    id: "installation",
    title: "Profile",
    text: "Profile is simple, if you are willing to add your details then click here and go to profile menu.From this option you can Update Profile,View Payment Transactions,Access your course certificate and Gradesheet,Find Job Opportunities,change password etc.. ",
    attachTo: { element: ".avtar-set", on: "left" },
    classes: "shepherd shepherd-welcome",
    scrollTo: true,
    buttons: [
      {
        type: "back",
        classes: "shepherd-button-secondary",
        text: "Back",
      },
      {
        type: "next",
        text: "Finish",
      },
    ],
  },
];
//end

CircularProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};
const responsive = {
  desktop: {
    breakpoint: { max: 4500, min: 1024 },
    items: 2,
    slidesToSlide: 1, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 550 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 550, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
};

class Mycourses extends Component {
  constructor(props) {
    super(props);
    const courses = [];
    const applcourses = [];
    const courseWebinarlist = [];
    const myquizlist = [];
    const eventlist = [];
    const viewmoreid = "";
    const learnerProfiledata = [];
    const profdetailscalculaton = "";

    this.state = {
      isLoading: false,
      courses,
      courseWebinarlist,
      myquizlist,
      applcourses,
      eventlist,
      viewmoreComponent: false,
      viewmoreid,
      eventmodalIsOpen: false,
      showCourseComponent: false,
      alleventsize: 0,
      learnerProfiledata,
      profdetailscalculaton,
      profilemodalIsOpen: false,
      issameaddress: false,
      selectedprofFile: null,
      error: null,
      mobileno: "",
      localAddress: "",
      permanantAddress: "",
      companyname: "",
      industrytype: "",
      yearexperience: "",
      monthexperience: "",
      linkedIn_url: "",
      firstName: "",
      avatarstatus: "",
      profdetailscalculaton: "",
      salutation: "",
    };

    this.openEventModal = this.openEventModal.bind(this);
    this.closeEventModal = this.closeEventModal.bind(this);
    this.openProfileModal = this.openProfileModal.bind(this);
    this.closeProfileModal = this.closeProfileModal.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleProfSubmit = this.handleProfSubmit.bind(this);
  }
  viewmore(e, id) {
    e.preventDefault();

    this.setState({
      viewmoreComponent: true,
      viewmoreid: id,
    });
  }

  viewless(e, id) {
    e.preventDefault();
    // alert(id);
    this.setState({
      viewmoreComponent: false,
    });
  }

  openEventModal() {
    this.setState({ eventmodalIsOpen: true });
  }

  closeEventModal() {
    this.setState({ eventmodalIsOpen: false });
  }
  openProfileModal() {
    this.setState({ profilemodalIsOpen: true });
  }

  closeProfileModal() {
    this.setState({ profilemodalIsOpen: false });
  }
  componentDidMount() {
    this.getAllCourses();
  }
  test() {
    alert("I'm ready for next page");
  }
  async getAllCourses() {
    this.setState({ isLoading: true, showCourseComponent: true });
    axios
      .post("Sample/mycourses")
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          this.setState({
            isLoading: false,
            courses: res.data.Nonapplication,
            applcourses: res.data.Application,
            courseWebinarlist: res.data.courseWebinarlist,
            myquizlist: res.data.myquizlist,
            eventlist: res.data.eventlist,
            showCourseComponent: false,
            alleventsize: res.data?.alleventsize,

            profdetailscalculaton: res.data.profdetailscalculaton,
            localAddress: res.data.localAddress,
            permanantAddress: res.data.permanantAddress,
            companyname: res.data.companyname,
            industrytype:res.data.industrytype,
            yearexperience: res.data.yearexperience,
            monthexperience: res.data.monthexperience,
            firstName: res.data.firstName,
            avatarstatus: res.data.avatarstatus,
            mobileno: res.data.mobileno,
            linkedIn_url: res.data.linkedIn_url,
          });
          // console.log("lastName"+ res.data.lastName );

          // console.log(this.state.applcourses);
          return res;
        }
        throw res;
      })
      .catch((error) => {
        toast.error("Something Went wrong", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  }
  sleep(milliseconds) {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  }
  handleSubmit(event) {
    //console.log("handleSubmit ");
    event.preventDefault();
    this.saveEventdetails();
  }
  async saveEventdetails() {
    this.setState({ loading: true });
    if (
      this.state.title === "" ||
      this.state.decription === "" ||
      this.state.date === "" ||
      this.state.fromtime === "" ||
      this.state.totime === ""
    ) {
      toast.error("All Fields are mandatory");
      await this.sleep(3000);
      this.setState({ loading: false });
      return;
    } else {
      var formData = new FormData();
      formData.append("cofflearn", localStorage.getItem("state"));
      formData.append("eventdate", this.state.date);
      formData.append("eventtitle", this.state.title);
      formData.append("eventdesc", this.state.decription);
      formData.append("eventfrom", this.state.fromtime);
      formData.append("eventto", this.state.totime);
      formData.append("ismail", this.state.ismail);
      // console.log("localStorage.getItem " + localStorage.getItem("state"));
      await axios
        .post("Sample/saveNewEventAll", formData)

        .then((res) => {
          if (res.data.status === "200") {
            toast.success("Event added Successfully ");
            this.setState({
              eventmodalIsOpen: false,
              loading: false,
              myquizlist: res.data.myquizlist,
              eventlist: res.data.eventlist,
            });
          } else {
            toast.error("Something went wrong");
          }
        });
    }
  }

  handleProfSubmit(event) {
    // console.log("handleProfSubmit===== ");
    event.preventDefault();
    this.saveProfdetails();
  }
  async setSameAddress() {
    this.setState({
      issameaddress: !this.state.issameaddress,
    });
    if (!this.state.issameaddress) {
      this.setState({
        localAddress: this.state.permanantAddress,
      });
    } else {
      this.setState({
        localAddress: "",
      });
    }
  }
  async saveProfdetails() {
    this.setState({ loading: true });
    console.log(regex.test(this.state.companyname));
    if (this.state.selectedprofFile) {
      let filename = this.state.selectedprofFile.name.split(".").pop();
      if (filename !== "jpg" && filename !== "jpeg" && filename !== "png") {
        // console.log("upload only" + filename);
        toast.error(" upload onlyjpg/jpeg/png files");
        await this.sleep(3000);
        this.setState({ loading: false });
        return;
      }
    }
    if (this.state.salutation === "") {
      toast.error("Please Select Salutation");
      await this.sleep(3000);
      this.setState({ loading: false, error: true });
      return;
    }
    if (this.state.companyname) {
      if (this.state.companyname.length <= 3) {
        toast.error(
          "Please enter valid Company Name.Company Name Should be more than 3 characters .. "
        );
        await this.sleep(3000);
        this.setState({ loading: false, error: true });
        return;
      }
    }
    // console.log(this.state.firstName)
    if (
      this.state.firstName === "" ||
      this.state.firstName === "null" ||
      this.state.firstName === null
    ) {
      toast.error("Please enter valid Name");
      await this.sleep(3000);
      this.setState({ loading: false, error: true });
      return;
    } else if (
      this.state.mobileno === "null" ||
      this.state.mobileno === null ||
      this.state.mobileno === ""
    ) {
      toast.error("Please enter valid Phone no");
      await this.sleep(3000);
      this.setState({ loading: false, error: true });
      return;
    } else if (
      this.state.permanantaddress === "" ||
      this.state.permanantaddress === "null" ||
      this.state.permanantaddress === null
    ) {
      toast.error("Please enter valid Permanant Address..");
      await this.sleep(3000);
      this.setState({ loading: false, error: true });
      return;
    } else if (
      this.state.linkedIn_url === "" ||
      this.state.linkedIn_url === "null" ||
      this.state.linkedIn_url === null
    ) {
      toast.error("Please enter valid linkedIn url..");
      await this.sleep(3000);
      this.setState({ loading: false, error: true });
      return;
    } else if (!Number(this.state.mobileno)) {
      toast.error("Please enter valid Phone no  ");
      await this.sleep(3000);
      this.setState({ loading: false, error: true });
      return;
    } else if (
      this.state.mobileno &&
      (this.state.mobileno.length < 6 || this.state.mobileno.length > 12)
    ) {
      toast.error("Please enter valid Phone no , without prefix ");
      await this.sleep(3000);
      this.setState({ loading: false, error: true });
      return;
    } else if (this.state.companyname && !regex.test(this.state.companyname)) {
      toast.error(
        "Please enter valid Company Name. Speacial Characters are not allowed .. "
      );
      await this.sleep(3000);
      this.setState({ loading: false, error: true });
      return;
    } else {
      var formData = new FormData();
      formData.append("cofflearn", localStorage.getItem("state"));

      formData.append("salutation", this.state.salutation);
      formData.append("fullName", this.state.firstName);
      formData.append("mobno", this.state.mobileno);
       formData.append("industrytype", this.state.industrytype);
      formData.append("permanantAddress", this.state.permanantAddress);
      formData.append("siteprofilelink", this.state.linkedIn_url);
      formData.append("companyname", this.state.companyname);
      formData.append("experienceyr", this.state.yearexperience);
      formData.append("experiencemonth", this.state.monthexperience);
      formData.append("avatar", this.state.selectedprofFile);
      await axios
        .post("Sample/saveRequiredPersonaldata", formData)

        .then((res) => {
          if (res.data.status === "200") {
            toast.success(res.data.msg);
            this.setState({
              profilemodalIsOpen: false,
              loading: false,
              profdetailscalculaton: res.data.profdetailscalculaton,
              // localAddress: res.data.localAddress,
              permanantAddress: res.data.permanantAddress,
              companyname: res.data.companyname,
              yearexperience: res.data.yearexperience,
              monthexperience: res.data.monthexperience,
              firstName: res.data.firstName,
              avatarstatus: res.data.avatarstatus,
              mobileno: res.data.mobileno,
              linkedIn_url: res.data.linkedIn_url,
            });
          } else {
            toast.error("Something went wrong");
          }
        });
    }
  }
  render() {
    return (
      <div>
        {this.state.showCourseComponent === true ? (
          <>
            <Spinner />
          </>
        ) : (
          <>
            {this.state.courses.length <= 0 ? (
              <section class="courseschedule1 padding-default bg-color1">
                <Row>
                  <Col xs="12" sm="12" md="8" lg="8">
                    <br />
                    <br />
                    <div className="bg-colorf">
                      <img
                        className="pd-img-first1"
                        src={firsthead}
                        alt="eduplusnow"
                        width="680"
                        height="120"
                      />
                      <p claSS="pt-4">
                        <p className="firstl-head-name">
                          Hi {localStorage.getItem("name")}
                        </p>
                        <p>
                          Catch up with your peers! Pick a course from our
                          catalog and start learning
                        </p>
                      </p>
                    </div>
                  </Col>
                  <Col xs="12" sm="12" md="4" lg="4">
                    <ShepherdTour steps={steps} tourOptions={tourOptions}>
                      <ShefButton />
                    </ShepherdTour>
                    <Card>
                      <div className="container">
                        <p className="heading-firstl">
                          Learn Today Innovate tomorrow
                        </p>
                        <p className="heading-firstlsmall-section">
                          Upgrade Your Technical Skills Take your career to new
                          heights with edu plus now online courses.
                        </p>
                        <p className="heading-firstlsmall-section1">
                          Scan this QR code on your camera app to download the
                          app.
                        </p>
                        <Row>
                          <Col
                            xs="12"
                            sm="12"
                            md="5"
                            lg="5"
                            className="mobileapp"
                          >
                            <img src={qrsvg} alt="qrcode" width="100" />
                          </Col>
                          <Col xs="12" sm="12" md="2" lg="2">
                            <p className="heading-firstlsmall-section1 pt-5">
                              OR
                            </p>
                          </Col>
                          <Col xs="12" sm="12" md="5" lg="5">
                            <img
                              className="pd-img-first1"
                              src={play}
                              alt="eduplusnow"
                              width="110"
                            />
                            <br />
                            <img
                              className="pd-img-first"
                              src={play}
                              alt="eduplusnow"
                              width="110"
                            />
                          </Col>
                        </Row>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </section>
            ) : (
              <>
                <section class="courseschedule1 padding-default bg-color1">
                  <Row>
                    <Col lg={8}>
                      <h2 className="my-course-heading">My Courses</h2>
                      <Carousel
                        responsive={responsive}
                        ssr
                        partialVisible
                        infinite={false}
                        autoPlaySpeed={5000}
                        autoPlay={
                          this.props.deviceType !== "mobile" ? true : false
                        }
                        beforeChange={() => this.setState({ isMoving: true })}
                        afterChange={() => this.setState({ isMoving: false })}
                        containerClass="first-carousel-container container"
                        deviceType={this.props.deviceType}
                      >
                        {this.state.courses.map((item) => (
                          <>
                            <Col lg={9} key={item.staticlink}>
                              <div className="padding-lr">
                                <Card className="card-my-course">
                                  <div className="row no-gutters">
                                    <div className="col-sm-5">
                                      <img
                                        src={item.crsimage}
                                        alt="Logo"
                                        className="my-course"
                                      />
                                    </div>

                                    <div className="col-sm-6">
                                      <div className="p-2 pl-4">
                                        <span className="heading-title">
                                          {item.coursename}
                                        </span>
                                      </div>
                                      {item.subscriptiondate != null ? (
                                        <>
                                          {" "}
                                          <div
                                            style={{
                                              position: "absolute",
                                              bottom: "5px",
                                            }}
                                          >
                                            <span
                                              className=""
                                              style={{
                                                "font-size": "12px",
                                                color: "gray",
                                              }}
                                            >
                                              Subscription Expires On :{" "}
                                              {item.subscriptiondate}
                                            </span>
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                  <div className="card-footer">
                                    {JSON.stringify(item.crs_expired) ===
                                    "false" ? (
                                      <>
                                        {item.ispersonal_details_required ===
                                        true ? (
                                          <>
                                            {this.state
                                              .profdetailscalculaton === 100 ? (
                                              <>
                                                {item.iscourseblocked ? (
                                                  <Link
                                                    to={{
                                                      pathname:
                                                        "/pay-installment",
                                                    }}
                                                  >
                                                    <button
                                                      color="primary"
                                                      style={{
                                                        borderRadius: 50,
                                                      }}
                                                      className=" btn btn-getstarteds1"
                                                    >
                                                      Pay Installment
                                                    </button>
                                                  </Link>
                                                ) : (
                                                  <Link
                                                    to={{
                                                      state: {
                                                        coflearner:
                                                          item.coflearner,
                                                      },
                                                      pathname: item.staticlink,
                                                    }}
                                                  >
                                                    <button
                                                      color="primary"
                                                      style={{
                                                        borderRadius: 50,
                                                      }}
                                                      className=" btn btn-getstarteds1"
                                                    >
                                                      View Course
                                                    </button>
                                                  </Link>
                                                )}
                                              </>
                                            ) : (
                                              <>
                                                <Link
                                                  onClick={
                                                    this.openProfileModal
                                                  }
                                                >
                                                  <button
                                                    color="primary"
                                                    style={{ borderRadius: 50 }}
                                                    className=" btn btn-getstarteds1"
                                                  >
                                                    View Course
                                                  </button>
                                                </Link>
                                              </>
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            {item.iscourseblocked ? (
                                              <Link
                                                to={{
                                                  pathname: "/pay-installment",
                                                }}
                                              >
                                                <button
                                                  color="primary"
                                                  style={{
                                                    borderRadius: 50,
                                                  }}
                                                  className=" btn btn-getstarteds1"
                                                >
                                                  Pay Installment
                                                </button>
                                              </Link>
                                            ) : (
                                              <Link
                                                to={{
                                                  state: {
                                                    coflearner: item.coflearner,
                                                  },
                                                  pathname: item.staticlink,
                                                }}
                                              >
                                                <button
                                                  color="primary"
                                                  style={{ borderRadius: 50 }}
                                                  className=" btn btn-getstarteds1"
                                                >
                                                  View Course
                                                </button>
                                              </Link>
                                            )}
                                          </>
                                        )}

                                        <CircularProgressWithLabel
                                          style={{
                                            width: "48px",
                                            height: "48px",
                                          }}
                                          className="float-right"
                                          value={item.percentComplete}
                                        />
                                      </>
                                    ) : (
                                      <span>
                                        <br />
                                        <span className="stat_o">
                                          Your Course Subscription has been
                                          Expired
                                        </span>
                                      </span>
                                    )}
                                    {/* View Course New Button Start */}
                                    {/* {JSON.stringify(item.crs_expired) ===
                                    "false" ? (
                                      item.ispersonal_details_required &&
                                      this.state.profdetailscalculaton ===
                                        100 ? (
                                        item.iscourseblocked ? (
                                          " Yes"
                                        ) : (
                                          "No"
                                        )
                                      ) : (
                                        "No"
                                      )
                                    ) : (
                                      <span>
                                        <br />
                                        <span className="stat_o">
                                          Your Course Subscription has been
                                          Expired
                                        </span>
                                      </span>
                                    )} */}
                                    {/* View Course New Button End */}
                                  </div>
                                </Card>
                              </div>
                            </Col>
                          </>
                        ))}
                      </Carousel>
                    </Col>
                    <Col lg={4}>
                      <Card style={{ height: " 260px" }}>
                        <CardHeader>
                          <Row>
                            <Col sm={10}>
                              <b>Upcoming Events ({this.state.alleventsize})</b>
                            </Col>
                            <Col sm={1}>
                              <Link onClick={this.openEventModal}>
                                <div style={{ height: "20px" }}>
                                  <Tooltip
                                    title="Add Event "
                                    aria-label="add Event"
                                  >
                                    <div className="addw">
                                      <div class="circle blue">
                                        <AddIcon />
                                      </div>
                                    </div>
                                  </Tooltip>
                                </div>
                              </Link>

                              <Modal
                                isOpen={this.state.eventmodalIsOpen}
                                onRequestClose={this.closeEventModal}
                                size="md"
                              >
                                <ModalHeader
                                  className="header-modalc"
                                  toggle={this.closeEventModal}
                                >
                                  Add Event
                                </ModalHeader>
                                <ModalBody>
                                  <div>
                                    <Row>
                                      <Col lg={12}>
                                        <form>
                                          <div class="row">
                                            <div class="col-sm-12">
                                              <TextField
                                                label="Title"
                                                type="text"
                                                id="title"
                                                name="title"
                                                style={{ width: "100%" }}
                                                onChange={(e) =>
                                                  this.setState({
                                                    title: e.target.value,
                                                  })
                                                }
                                              />
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-sm-12">
                                              <TextField
                                                label="Description"
                                                style={{ width: "100%" }}
                                                type="text"
                                                id="decription"
                                                name="decription"
                                                multiline
                                                rowsMax={2}
                                                onChange={(e) =>
                                                  this.setState({
                                                    decription: e.target.value,
                                                  })
                                                }
                                              />
                                            </div>
                                          </div>{" "}
                                          <br />
                                          <div class="row">
                                            <div class="col-sm-12">
                                              <TextField
                                                id="date"
                                                type="date"
                                                name="date"
                                                label="Date"
                                                variant="standard"
                                                style={{ width: "50%" }}
                                                defaultValue={new Date()}
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                onChange={(e) =>
                                                  this.setState({
                                                    date: e.target.value,
                                                  })
                                                }
                                              />
                                            </div>
                                          </div>
                                          <br />
                                          <div class="row">
                                            <div class="col-sm-6">
                                              {/* <label>
                                            <b> From :</b>
                                          </label> */}
                                              <TextField
                                                id="fromtime"
                                                type="time"
                                                name="fromtime"
                                                label="From"
                                                variant="standard"
                                                style={{ width: "100%" }}
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                onChange={(e) =>
                                                  this.setState({
                                                    fromtime: e.target.value,
                                                  })
                                                }
                                              />
                                            </div>
                                            <div class="col-sm-6">
                                              {/* <label>
                                            <b> To :</b>
                                          </label> */}

                                              <TextField
                                                id="totime"
                                                type="time"
                                                name="totime"
                                                label="To"
                                                variant="standard"
                                                style={{ width: "100%" }}
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                onChange={(e) =>
                                                  this.setState({
                                                    totime: e.target.value,
                                                  })
                                                }
                                              />
                                            </div>
                                          </div>
                                          <br />
                                          <div class="row">
                                            <div
                                              class="col-sm-12"
                                              style={{ display: "flex" }}
                                            >
                                              <FormControlLabel
                                                control={
                                                  <Checkbox
                                                    name="ismail"
                                                    checked={this.state.ismail}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        ismail:
                                                          e.target.type ===
                                                          "checkbox"
                                                            ? e.target.checked
                                                            : e.target.value,
                                                      })
                                                    }
                                                    color="primary"
                                                  />
                                                }
                                                label="Remind me on E-mail"
                                              />
                                            </div>
                                          </div>
                                          <br />
                                          <div className="row">
                                            <div className="col-lg-12 text-center">
                                              <Button
                                                variant="contained"
                                                color="primary"
                                                //  className="buttonSuccess"
                                                disabled={this.state.loading}
                                                onClick={this.handleSubmit}
                                              >
                                                Save
                                              </Button>

                                              {this.state.loading === true ? (
                                                <CircularProgress
                                                  size={24}
                                                  color="green"
                                                  className="buttonProgress1"
                                                />
                                              ) : (
                                                ""
                                              )}
                                            </div>
                                          </div>
                                        </form>
                                      </Col>
                                    </Row>
                                  </div>
                                </ModalBody>
                              </Modal>
                            </Col>
                          </Row>
                        </CardHeader>
                        <CardBody className="up-card">
                          <div id="style-6" class="desc scrollbar-upcom">
                            <span class="force-overflow-upcom">
                              {this.state.courseWebinarlist.map((itemname) => (
                                <>
                                  {itemname.wlink !== null ||
                                  itemname.wlink !== "" ? (
                                    <>
                                      <div className="coursecat2">
                                        <Card
                                          style={{
                                            width: "100%",

                                            //border: "1px solid #232",
                                            padding: "2px",
                                            height: "auto",
                                            boxShadow: "rgb(162, 163, 159)",
                                          }}
                                        >
                                          <CardBody>
                                            <Row>
                                              <Col sm={12}>
                                                {/* <Link to={itemname.wlink}>
                                              {" "}
                                              {itemname.title}
                                            </Link> */}
                                                <Label>
                                                  <a
                                                    href={itemname.wlink}
                                                    target="_blank"
                                                  >
                                                    {" "}
                                                    <FontAwesomeIcon
                                                      icon={faVideo}
                                                      color="red"
                                                    />
                                                    &nbsp;&nbsp;
                                                    {itemname.title}
                                                  </a>
                                                </Label>
                                              </Col>
                                            </Row>
                                            <Row>
                                              <Col sm={6}>
                                                <p>
                                                  {" "}
                                                  <FontAwesomeIcon
                                                    icon={faCalendarAlt}
                                                    color="blue"
                                                  />
                                                  &nbsp;
                                                  {itemname.webinardate}
                                                </p>
                                              </Col>

                                              <Col sm={6}>
                                                {" "}
                                                <FontAwesomeIcon
                                                  icon={faClock}
                                                  color="orange"
                                                />
                                                &nbsp;
                                                {itemname.time}
                                              </Col>
                                            </Row>
                                            <br />

                                            {this.state.viewmoreComponent ===
                                              true &&
                                            this.state.viewmoreid ===
                                              itemname.eventid ? (
                                              <>
                                                <Row>
                                                  <Col sm={12}>
                                                    <Link
                                                      onClick={(e) =>
                                                        this.viewless(
                                                          e,
                                                          itemname.eventid
                                                        )
                                                      }
                                                    >
                                                      <div
                                                        style={{
                                                          textAlign: "right",
                                                        }}
                                                      >
                                                        <Tooltip
                                                          title="View Less "
                                                          aria-label="View Less"
                                                        >
                                                          <div className="add3">
                                                            <div class="circle inherit">
                                                              <FontAwesomeIcon
                                                                icon={faAngleUp}
                                                                style={{
                                                                  marginTop:
                                                                    "4px",
                                                                }}
                                                              />
                                                            </div>
                                                          </div>
                                                          {/* <Fab
                                                            color="inherit"
                                                            size="small"
                                                          >
                                                            <FontAwesomeIcon
                                                              size="1x"
                                                              icon={faAngleUp}
                                                            />
                                                          </Fab> */}
                                                        </Tooltip>
                                                      </div>
                                                    </Link>
                                                    <p>
                                                      <span
                                                        dangerouslySetInnerHTML={{
                                                          __html:
                                                            itemname.description,
                                                        }}
                                                      />
                                                    </p>
                                                  </Col>
                                                </Row>
                                              </>
                                            ) : (
                                              <Row>
                                                <Col sm={12}>
                                                  <Link
                                                    onClick={(e) =>
                                                      this.viewmore(
                                                        e,
                                                        itemname.eventid
                                                      )
                                                    }
                                                  >
                                                    <div
                                                      style={{
                                                        textAlign: "right",
                                                      }}
                                                    >
                                                      <Tooltip
                                                        title="View more "
                                                        aria-label="View more"
                                                      >
                                                        <div className="add3">
                                                          <div class="circle blue">
                                                            <FontAwesomeIcon
                                                              icon={faAngleDown}
                                                              style={{
                                                                marginTop:
                                                                  "4px",
                                                              }}
                                                            />
                                                          </div>
                                                        </div>
                                                      </Tooltip>
                                                    </div>
                                                  </Link>
                                                </Col>
                                              </Row>
                                            )}
                                          </CardBody>
                                        </Card>
                                      </div>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </>
                              ))}

                              {this.state.eventlist.map((itemname) => (
                                <>
                                  {itemname.wlink !== null ||
                                  itemname.wlink !== "" ? (
                                    <>
                                      <div className="coursecat2">
                                        <Card
                                          style={{
                                            width: "100%",
                                            //border: "1px solid #232",
                                            padding: "2px",
                                            height: "auto",
                                            boxShadow: "rgb(162, 163, 159)",
                                          }}
                                        >
                                          <CardBody>
                                            <Row>
                                              <Col sm={12}>
                                                {/* <Link to={itemname.wlink}>
                                              {" "}
                                              {itemname.title}
                                            </Link> */}
                                                <Label>
                                                  <EventIcon color="secondary" />
                                                  &nbsp;&nbsp;
                                                  {itemname.title}
                                                </Label>
                                              </Col>
                                            </Row>
                                            <Row>
                                              <Col sm={6}>
                                                <p>
                                                  {" "}
                                                  <FontAwesomeIcon
                                                    icon={faCalendarAlt}
                                                    color="blue"
                                                  />
                                                  &nbsp;
                                                  {itemname.ondate}
                                                </p>
                                              </Col>

                                              <Col sm={6}>
                                                {" "}
                                                <FontAwesomeIcon
                                                  icon={faClock}
                                                  color="orange"
                                                />
                                                &nbsp;
                                                {itemname.ontime}
                                              </Col>
                                            </Row>

                                            {this.state.viewmoreComponent ===
                                              true &&
                                            this.state.viewmoreid ===
                                              itemname.eventid ? (
                                              <>
                                                <Row>
                                                  <Col sm={12}>
                                                    <Link
                                                      onClick={(e) =>
                                                        this.viewless(
                                                          e,
                                                          itemname.eventid
                                                        )
                                                      }
                                                    >
                                                      <div
                                                        style={{
                                                          float: "right",
                                                        }}
                                                      >
                                                        <Tooltip
                                                          title="View Less "
                                                          aria-label="View Less"
                                                        >
                                                          <div className="add3">
                                                            <div class="circle inherit">
                                                              <FontAwesomeIcon
                                                                icon={faAngleUp}
                                                                style={{
                                                                  marginTop:
                                                                    "4px",
                                                                }}
                                                              />
                                                            </div>
                                                          </div>
                                                          {/* <Fab
                                                            color="inherit"
                                                            size="small"
                                                          >
                                                            <FontAwesomeIcon
                                                              size="1x"
                                                              icon={faAngleUp}
                                                            />
                                                          </Fab> */}
                                                        </Tooltip>
                                                      </div>
                                                    </Link>

                                                    <p>
                                                      {" "}
                                                      <span
                                                        dangerouslySetInnerHTML={{
                                                          __html:
                                                            itemname.description,
                                                        }}
                                                      />
                                                    </p>
                                                  </Col>
                                                </Row>
                                              </>
                                            ) : (
                                              <Row>
                                                <Col sm={12}>
                                                  <Link
                                                    onClick={(e) =>
                                                      this.viewmore(
                                                        e,
                                                        itemname.eventid
                                                      )
                                                    }
                                                  >
                                                    <div
                                                      style={{
                                                        float: "right",
                                                      }}
                                                    >
                                                      <Tooltip
                                                        title="View more "
                                                        aria-label="View more"
                                                      >
                                                        <div className="add3">
                                                          <div class="circle blue">
                                                            <FontAwesomeIcon
                                                              icon={faAngleDown}
                                                              style={{
                                                                marginTop:
                                                                  "4px",
                                                              }}
                                                            />
                                                          </div>
                                                        </div>
                                                        {/* <Fab
                                                          color="primary"
                                                          size="small"
                                                        >3
                                                          <FontAwesomeIcon
                                                            icon={faAngleDown}
                                                            size="1x"
                                                          />
                                                        </Fab> */}
                                                      </Tooltip>
                                                    </div>
                                                  </Link>
                                                </Col>
                                              </Row>
                                            )}
                                          </CardBody>
                                        </Card>
                                      </div>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </>
                              ))}

                              {this.state.myquizlist.map((itemn) => (
                                <>
                                  {itemn.quizid !== null ||
                                  itemn.quizid !== "" ? (
                                    <>
                                      <div className="coursecat2">
                                        <Card
                                          style={{
                                            width: "100%",
                                            //border: "1px solid #232",
                                            padding: "2px",
                                            height: "auto",
                                            boxShadow: "rgb(162, 163, 159)",
                                          }}
                                        >
                                          <CardBody>
                                            <Row>
                                              <Col sm={12}>
                                                <p>
                                                  <FontAwesomeIcon
                                                    icon={faPaperPlane}
                                                    color="green"
                                                  />
                                                  &nbsp; Quiz : &nbsp;&nbsp;{" "}
                                                  {itemn.title}
                                                </p>
                                              </Col>
                                            </Row>
                                            <Row>
                                              <Col sm={6}>
                                                <p>
                                                  {" "}
                                                  <FontAwesomeIcon
                                                    icon={faCalendarAlt}
                                                    color="blue"
                                                  />
                                                  &nbsp;
                                                  {itemn.startdate}
                                                </p>
                                              </Col>

                                              <Col sm={6}>
                                                {" "}
                                                <FontAwesomeIcon
                                                  icon={faClock}
                                                  color="orange"
                                                />
                                                &nbsp;
                                                {itemn.starttime} -{" "}
                                                {itemn.endtime}
                                              </Col>
                                            </Row>

                                            {this.state.viewmoreComponent ===
                                              true &&
                                            this.state.viewmoreid ===
                                              itemn.quizid ? (
                                              <>
                                                <Row>
                                                  <Col sm={12}>
                                                    <Link
                                                      onClick={(e) =>
                                                        this.viewless(
                                                          e,
                                                          itemn.quizid
                                                        )
                                                      }
                                                    >
                                                      <div
                                                        style={{
                                                          float: "right",
                                                        }}
                                                      >
                                                        <Tooltip
                                                          title="View Less "
                                                          aria-label="View Less"
                                                        >
                                                          <div className="add3">
                                                            <div class="circle inherit">
                                                              <FontAwesomeIcon
                                                                icon={faAngleUp}
                                                                style={{
                                                                  marginTop:
                                                                    "4px",
                                                                }}
                                                              />
                                                            </div>
                                                          </div>

                                                          {/* <Fab
                                                            color="inherit"
                                                            size="small"
                                                          >
                                                            <FontAwesomeIcon
                                                              size="1x"
                                                              icon={faAngleUp}
                                                            />
                                                          </Fab> */}
                                                        </Tooltip>
                                                      </div>
                                                    </Link>

                                                    <p>
                                                      <span
                                                        dangerouslySetInnerHTML={{
                                                          __html:
                                                            itemn.description,
                                                        }}
                                                      />
                                                    </p>
                                                  </Col>
                                                </Row>
                                              </>
                                            ) : (
                                              <Row>
                                                <Col sm={12}>
                                                  <Link
                                                    onClick={(e) =>
                                                      this.viewmore(
                                                        e,
                                                        itemn.quizid
                                                      )
                                                    }
                                                  >
                                                    <div
                                                      style={{
                                                        float: "right",
                                                      }}
                                                    >
                                                      <Tooltip
                                                        title="View more "
                                                        aria-label="View more"
                                                      >
                                                        <div className="add3">
                                                          <div class="circle blue">
                                                            <FontAwesomeIcon
                                                              icon={faAngleDown}
                                                              style={{
                                                                marginTop:
                                                                  "4px",
                                                              }}
                                                            />
                                                          </div>
                                                        </div>
                                                      </Tooltip>
                                                    </div>
                                                  </Link>
                                                </Col>
                                              </Row>
                                            )}
                                          </CardBody>
                                        </Card>
                                      </div>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </>
                              ))}
                            </span>
                          </div>
                        </CardBody>
                      </Card>
                      {/* <div style={{ "padding-top": "5px" }}>
                        <a
                          href="https://t.me/eduplusnow"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <Button color="primary" style={{ borderRadius: 50 }}>
                            Connect with us on telegram
                          </Button>{" "}
                        </a>
                      </div> */}
                    </Col>
                  </Row>
                </section>
              </>
            )}
            {this.state.applcourses.length <= 0 ? (
              ""
            ) : (
              <Row>
                <Col lg={9}>
                  <br />
                  <h4>Applied for Courses</h4>
                  <br />
                  {this.state.applcourses.map((item) => (
                    <>
                      <Col lg={4} key={item.staticlink}>
                        <Card style={{ width: " 500px" }}>
                          <div className="row no-gutters">
                            <div className="col-sm-4">
                              <img
                                src={item.crsimage}
                                alt="Logo"
                                width="160"
                                height="160"
                              />
                            </div>
                            <div className="col-sm-8">
                              <div className="card-body">
                                <h5 className="card-title">
                                  {item.cname}
                                  <br />
                                  <br />
                                  <center>
                                    <Button
                                      color="primary"
                                      style={{ borderRadius: 50 }}
                                    >
                                      Track My Application
                                    </Button>
                                  </center>
                                </h5>
                              </div>
                            </div>
                          </div>
                          <CardFooter>
                            <div className="row no-gutters">
                              <div className="col-sm-3"></div>
                              Application Status :
                              {item.status === "Incomplete" ? (
                                <span style={{ color: "red" }}>
                                  &nbsp; {item.status}
                                </span>
                              ) : (
                                <span style={{ color: "green" }}>
                                  &nbsp; {item.status}
                                </span>
                              )}
                            </div>
                          </CardFooter>
                        </Card>
                        <br />
                      </Col>
                    </>
                  ))}
                </Col>
              </Row>
            )}
            <>
              <Modal
                isOpen={this.state.profilemodalIsOpen}
                onRequestClose={this.closeProfileModal}
                size="md"
              >
                <ModalHeader
                  className="header-modalc"
                  toggle={this.closeProfileModal}
                >
                  Add Profile data
                </ModalHeader>
                <ModalBody>
                  <div>
                    <Row>
                      <Col lg={12}>
                        <form>
                          <div class="row">
                            <div class="col-sm-2">
                              <FormControl>
                                <InputLabel id="demo-simple-select-label">
                                  Select
                                </InputLabel>
                                <Select
                                  error={
                                    this.state.error && !this.state.salutation
                                  }
                                  labelId="demo-simple-select-label"
                                  name="salutation"
                                  id="salutation"
                                  onChange={(e) =>
                                    this.setState({
                                      salutation: e.target.value,
                                      error: false,
                                    })
                                  }
                                >
                                  <MenuItem value="Mr.">Mr. </MenuItem>
                                  <MenuItem value="Ms.">Ms. </MenuItem>
                                  <MenuItem value="Mrs.">Mrs. </MenuItem>
                                </Select>
                              </FormControl>
                            </div>
                            <div class="col-sm-10">
                              <TextField
                                error={
                                  this.state.error && !this.state.firstName
                                }
                                label="Name to appear  on certificate"
                                style={{
                                  width: "100%",
                                }}
                                type="text"
                                id="firstName"
                                name="firstName"
                                required
                                rowsMax={2}
                                defaultValue={this.state.firstName}
                                onChange={(e) =>
                                  this.setState({
                                    firstName: e.target.value,
                                    error: false,
                                  })
                                }
                              />
                            </div>
                          </div>{" "}
                          <div class="row">
                            <div class="col-sm-12">
                              <TextField
                                error={this.state.error && !this.state.mobileno}
                                id="mobileno"
                                type="number"
                                name="mobileno"
                                label=" Mobile  No. "
                                required
                                style={{
                                  width: "100%",
                                }}
                                value={this.state.mobileno}
                                onChange={(e) =>
                                  this.setState({
                                    mobileno: e.target.value,
                                    error: false,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <TextField
                                error={
                                  this.state.error &&
                                  !this.state.permanantAddress
                                }
                                id="permanantAddress"
                                type="text"
                                name="permanantAddress"
                                label=" Enter Permanent  Address "
                                rowsMax={2}
                                style={{
                                  width: "100%",
                                }}
                                required
                                value={this.state.permanantAddress}
                                onChange={(e) =>
                                  this.setState({
                                    permanantAddress: e.target.value,
                                    error: false,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <br />
                          <div class="row">
                            <div class="col-sm-12">
                              <TextField
                                label="LinkedIn Profile Link"
                                style={{
                                  width: "100%",
                                }}
                                error={
                                  this.state.error && !this.state.linkedIn_url
                                }
                                type="text"
                                id="linkedIn_url"
                                name="linkedIn_url"
                                required
                                value={this.state.linkedIn_url}
                                onChange={(e) =>
                                  this.setState({
                                    linkedIn_url: e.target.value,
                                    error: false,
                                  })
                                }
                              />
                            </div>
                          </div>{" "}
                          <br />
                          <div class="row">
                            <div class="col-sm-12">
                              <TextField
                                label="Company Name"
                                style={{
                                  width: "100%",
                                }}
                                type="text"
                                id="companyname"
                                name="companyname"
                                rowsMax={2}
                                value={this.state.companyname}
                                onChange={(e) =>
                                  this.setState({
                                    companyname: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <br />
                          <div class="row">
                            <div class="col-sm-6">
                              <TextField
                                label="Experience in Years"
                                style={{
                                  width: "100%",
                                }}
                                type="number"
                                id="yearexperience"
                                name="yearexperience"
                                value={this.state.yearexperience}
                                onChange={(e) =>
                                  this.setState({
                                    yearexperience: e.target.value,
                                  })
                                }
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                            </div>
                            <div class="col-sm-6">
                              <TextField
                                label="Experience in Months"
                                style={{
                                  width: "100%",
                                }}
                                type="number"
                                id="monthexperience"
                                name="monthexperience"
                                value={this.state.monthexperience}
                                onChange={(e) =>
                                  this.setState({
                                    monthexperience: e.target.value,
                                  })
                                }
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                            </div>
                          </div>{" "}
                          <br />
                          <div class="row">
                            <div class="col-sm-12">
                              <TextField
                                label="Industry Type "
                                style={{
                                  width: "100%",
                                }}
                                type="text"
                                id="industrytype"
                                name="industrytype"
                                rowsMax={2}
                                value={this.state.industrytype}
                                onChange={(e) =>
                                  this.setState({
                                    industrytype: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <br />
                          {this.state.avatarstatus === "No" ? (
                            <>
                              <div class="row ">
                                <div class="col-sm-12">
                                  <Label> Upload Profile Photo :</Label>
                                  <input
                                    class="form-control"
                                    id="selectedprofFile"
                                    type="file"
                                    required
                                    name="selectedprofFile"
                                    onChange={(e) =>
                                      this.setState({
                                        selectedprofFile: e.target.files[0],
                                      })
                                    }
                                  />
                                </div>
                              </div>{" "}
                              <br />
                            </>
                          ) : (
                            <></>
                          )}
                          <div className="row">
                            <div className="col-lg-12 text-center">
                              <Button
                                variant="contained"
                                color="primary"
                                //  className="buttonSuccess"
                                disabled={this.state.loading}
                                onClick={this.handleProfSubmit}
                              >
                                Save
                              </Button>

                              {this.state.loading === true ? (
                                <CircularProgress
                                  size={24}
                                  color="green"
                                  className="buttonProgress1"
                                />
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </form>
                      </Col>
                    </Row>
                  </div>
                </ModalBody>
              </Modal>
            </>
            {this.state.isLoading ? "" : <Explore />}
          </>
        )}
      </div>
    );
  }
}

export default Mycourses;
